import moment from 'moment';
import { EVENT_TYPES } from '@/constants';
import { returnIndexOfEventIds } from './eventsHelper';

export const removeNulls = (obj) => {
	var isArray = obj instanceof Array;
	for (var k in obj) {
		if (obj[k] === null) isArray ? obj.splice(k, 1) : delete obj[k];
		else if (typeof obj[k] == 'object') removeNulls(obj[k]);
		if (isArray && obj.length == k) removeNulls(obj);
	}
	return obj;
};

export const formatDisplayableTime = (seconds_to_format, decimal_places = 2) => {
	if (seconds_to_format == undefined) {
		return '00:00.00';
	}
	// console.log("typeof", typeof(seconds_to_format));
	if (seconds_to_format < 0) {
		return 'NEGATIVE';
	}

	var sec_num = parseInt(seconds_to_format, 10); //parseInt(this, 10); // don't forget the second param
	var hours = Math.floor(sec_num / 3600);
	var minutes = Math.floor((sec_num - hours * 3600) / 60);
	var seconds = sec_num - hours * 3600 - minutes * 60;
	var milliseconds = seconds_to_format.toString(); //(this).toString()
	var digitsBeforeDecimal = parseInt(seconds_to_format).toString().length; //parseInt(this).toString().length

	var mil_secs = '';
	if (milliseconds[digitsBeforeDecimal + 1] !== undefined && decimal_places >= 1) {
		mil_secs += milliseconds[digitsBeforeDecimal + 1];
	}
	if (milliseconds[digitsBeforeDecimal + 2] !== undefined && decimal_places >= 2) {
		mil_secs += milliseconds[digitsBeforeDecimal + 2];
	}

	if (hours < 10) {
		hours = '0' + hours;
	}
	if (minutes < 10) {
		minutes = '0' + minutes;
	}
	if (seconds < 10) {
		seconds = '0' + seconds;
	}

	let number_of_trailing_zeros = 2 - mil_secs.length;
	if (number_of_trailing_zeros + mil_secs.length > decimal_places) {
		number_of_trailing_zeros = decimal_places - mil_secs.length;
	}
	for (let i = 0; i < number_of_trailing_zeros; i++) {
		mil_secs = mil_secs + '0';
	}

	if (hours > 0) {
		return hours + ':' + minutes + ':' + seconds + (decimal_places >= 1 ? '.' + mil_secs : '');
	} else {
		return minutes + ':' + seconds + (decimal_places >= 1 ? '.' + mil_secs : '');
	}
};

export const transformScriptArray = (array) => {
	if (Array.isArray(array) == false) {
		array = [array];
	}

	return array.map((obj) => {
		const newObj = { ...obj };

		if (newObj.cues) {
			newObj.events = newObj.cues.map((cue) => {
				const newCue = { ...cue };
				if (newCue.cue_ID) {
					newCue.event_id = newCue.cue_ID;
					delete newCue.cue_ID;
				}
				return newCue;
			});
			delete newObj.cues;
		}

		if (newObj.script_atributes) {
			newObj.show_attributes = newObj.script_atributes;
			delete newObj.script_atributes;
		}

		if (newObj.script_name) {
			newObj.show_name = newObj.script_name;
			delete newObj.script_name;
		}

		if (newObj.ignite_code) {
			newObj.show_code = newObj.ignite_code;
			delete newObj.ignite_code;
		}

		return newObj;
	});
};

export const deTransformScriptArray = (array) => {
	if (Array.isArray(array) == false) {
		array = [array];
	}
	return array.map((obj) => {
		const newObj = { ...obj };

		if (newObj.events) {
			newObj.cues = newObj.events.map((event) => {
				const newEvent = { ...event };
				if (newEvent.event_id) {
					newEvent.cue_ID = newEvent.event_id;
					delete newEvent.event_id;
				}
				return newEvent;
			});
			delete newObj.events;
		}

		if (newObj.show_attributes) {
			newObj.script_atributes = newObj.show_attributes;
			delete newObj.show_attributes;
		}

		if (newObj.show_name) {
			newObj.script_name = newObj.show_name;
			delete newObj.show_name;
		}

		if (newObj.show_code) {
			newObj.ignite_code = newObj.show_code;
			delete newObj.show_code;
		}

		return newObj;
	});
};

export function chr4() {
	return Math.random().toString(16).slice(-4);
}

export function frequencyOfChar(char, string) {
	let frequency = 0;
	for (const letter of string) {
		if (letter == char) {
			frequency++;
		}
	}
	return frequency;
}

export function convertFormattedStringIntoSeconds(formatedString) {
	var timeElements = splitFormatedStringIntoTimeElements(formatedString);
	//console.log(timeElements);
	var miliSecFormated = 0.0;
	if (timeElements.milSec.length < 2) {
		miliSecFormated = parseInt(timeElements.milSec) * 0.1;
	} else {
		miliSecFormated = parseInt(timeElements.milSec) * 0.01;
	}
	var seconds = parseInt(timeElements.hour) * 60 * 60 + parseInt(timeElements.min) * 60 + parseInt(timeElements.sec) + miliSecFormated;
	return seconds;
}

export function splitFormatedStringIntoTimeElements(formatedString) {
	var splitTime = formatedString.split(':');
	var hourString = '0';
	var minString = '0';
	var secondString = '0';
	var miliSecondString = '0';
	if (splitTime.length == 3) {
		hourString = splitTime[0];
		minString = splitTime[1];
	} else if (splitTime.length == 2) {
		minString = splitTime[0];
	}
	if (splitTime[splitTime.length - 1].indexOf('.') != -1) {
		var secondsAndMillSec = splitTime[splitTime.length - 1].split('.');
		splitTime[splitTime.length - 1] = secondsAndMillSec[0];
		splitTime.push(secondsAndMillSec[1]);
		secondString = secondsAndMillSec[0];
		miliSecondString = secondsAndMillSec[1];
	} else {
		secondString = splitTime[splitTime.length - 1];
	}
	return { 'hour': hourString, 'min': minString, 'sec': secondString, 'milSec': miliSecondString };
}

export function prettyDate(string) {
	let date = moment(string).utc();
	return date.calendar(null, {
		sameDay: '[Today At] h:mm',
		lastDay: '[Yesterday At] h:mm',
		lastWeek: '[Last] dddd',
		sameElse: 'MMMM DD, YYYY',
	});
}

export function prettyFileSize(string, decimal_point = 2) {
	let bytes = string;
	if (bytes == 0) return '0 Bytes';
	const k = 1000;
	const dm = decimal_point || 2;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function getSafeString(string) {
	if (string == undefined || string == null) {
		return '';
	}
	return string.toString();
}

export function convertSecondsToTime(input_seconds) {
	const minutes = Math.floor(input_seconds / 60);

	const remaining_seconds = input_seconds % 60;

	// Extract whole seconds and 1/100th of a second
	const whole_seconds = Math.floor(remaining_seconds);
	const hundredths = Math.round((remaining_seconds - whole_seconds) * 100);

	return {
		minutes: minutes,
		seconds: whole_seconds,
		milliseconds: hundredths,
	};
}

export function toDisplayableTime(seconds_to_format, decimal_places) {
	return formatDisplayableTime(seconds_to_format, decimal_places);
}

export function toSmallestDisplayTime(string, event_type = EVENT_TYPES.PYRO) {
	let number_of_decimals = event_type == EVENT_TYPES.PYRO ? 1 : 2;
	return leastDisplayTime(string, number_of_decimals);
}

function leastDisplayTime(seconds_to_format, decimal_places = 2) {
	if (seconds_to_format < 0) {
		return 'NEGATIVE';
	}

	var sec_num = parseInt(seconds_to_format, 10); // don't forget the second param
	var hours = Math.floor(sec_num / 3600);
	var minutes = Math.floor((sec_num - hours * 3600) / 60);
	var seconds = sec_num - hours * 3600 - minutes * 60;
	var milliseconds = seconds_to_format.toString();
	var digits_before_decimal = parseInt(seconds_to_format).toString().length;

	var mil_secs = '';
	if (milliseconds[digits_before_decimal + 1] !== undefined && decimal_places >= 1) {
		mil_secs += milliseconds[digits_before_decimal + 1];
	}
	if (milliseconds[digits_before_decimal + 2] !== undefined && decimal_places >= 2) {
		mil_secs += milliseconds[digits_before_decimal + 2];
	}

	if (hours < 10) {
		hours = '0' + hours;
	}
	if (minutes < 10 && hours > 0) {
		minutes = '0' + minutes;
	}
	if (seconds < 10 && minutes > 0) {
		seconds = '0' + seconds;
	}

	let number_of_trailing_zeros = 2 - mil_secs.length;
	if (number_of_trailing_zeros + mil_secs.length > decimal_places) {
		number_of_trailing_zeros = decimal_places - mil_secs.length;
	}
	for (let i = 0; i < number_of_trailing_zeros; i++) {
		mil_secs = mil_secs + '0';
	}

	if (hours > 0) {
		return hours + ':' + minutes + ':' + seconds + (decimal_places >= 1 ? '.' + mil_secs : '');
	} else if (minutes > 0) {
		return minutes + ':' + seconds + (decimal_places >= 1 ? '.' + mil_secs : '');
	} else if (mil_secs == 0) {
		return seconds + 's';
	} else {
		return seconds + (decimal_places >= 1 ? '.' + mil_secs : '') + 's';
	}
}

export function toDisplayableCategory(input_string) {
	if (input_string == undefined || null) {
		return '';
	}
	if (input_string == '') {
		return '';
	}

	switch (input_string.toLowerCase()) {
		case 'module_cake':
			return 'Module (Cake Slice)';
		case 'fan_cake':
			return 'Fan Cake';
		case 'zipper_cake':
			return 'Zipper Cake';
		case 'cake_200g':
			return '200g Multi-shot Cakes';
		case 'cake_350g':
			return '350g Multi-shot Cakes';
		case 'cake_500g':
			return '500g Multi-shot Cakes';
		case 'w_cake':
			return 'W Multi-shot Cakes';
		case 'v_cake':
			return 'V Multi-shot Cakes';
		case 'noab_cake':
			return 'N.O.A.B Cakes (9 on a Board)';
		case 'cakes':
			return 'Multi-shot Cakes';

		case '1.75in_shell':
			return '1.75" Shells';
		case '2in_shell':
			return '2" Shells';
		case '2.5in_shell':
			return '2.5" Shells';
		case '3in_shell':
			return '3" Shells';
		case '4in_shell':
			return '4" Shells';
		case '5in_shell':
			return '5" Shells';
		case '6in_shell':
			return '6" Shells';
		case '8in_shell':
			return '8" Shells';
		case '10in_shell':
			return '10" Shells';
		case '12in_shell':
			return '12" Shells';
		case '16in_shell':
			return '16" Shells';

		case 'mine':
			return 'Mine';
		case 'missiles':
			return 'Missiles';
		case 'comets':
			return 'Comets';
		case 'artillery_shells':
			return 'Artillery Shells';
		case 'roman_candle':
			return 'Roman Candle';
		case 'rockets':
			return 'Rockets';
		case 'single_shot_tubes':
			return 'Single Shot Tubes';

		case 'flame_pot':
			return 'Flame Pot';
		case 'fountain':
			return 'Fountain';
		case 'gerb':
			return 'Gerb';
		case 'strobe_pot':
			return 'Strobe Pot';
		case 'wheel':
			return 'Wheel';

		case 'novelties':
			return 'Novelties';
		case 'firecrackers':
			return 'Firecrackers';
		case 'laterns':
			return 'Lantern';
		case 'parachutes':
			return 'Parachutes';
		case 'smoke_bombs':
			return 'Smoke Bombs';
		case 'assortment':
			return 'Assortment';

		case 'burst':
			return 'Burst';
		case 'line_rocket':
			return 'Line Rocket';
		case 'punk':
			return 'Punk';
		case 'waterfall':
			return 'Waterfall';
		case 'girandola':
			return 'Girandola';
		case 'lance':
			return 'Lance';

		case 'ignitor':
			return 'Ignitor';
		case 'fuse':
			return 'Fuse';

		case 'other':
			return 'Other';

		default:
			return 'Other';
	}
}

export function toDisplayableDMXCategory(input_string) {
	if (input_string == undefined || null) {
		return '';
	}
	if (input_string == '') {
		return '';
	}

	switch (input_string.toLowerCase()) {
		case 'air':
			return 'Air';
		case 'bubble':
			return 'Bubble';
		case 'confetti':
			return 'Confetti';
		case 'drop':
			return 'Drop';
		case 'snow':
			return 'Snow';
		case 'spark':
			return 'Spark';

		case 'flame':
			return 'Flame';
		case 'fog':
			return 'Fog';
		case 'smoke':
			return 'Smoke';
		case 'cyro':
			return 'Cyro';
		case 'co2':
			return 'CO2';

		case 'light':
			return 'Light';

		case 'other':
			return 'Other';

		default:
			return 'Other';
	}
}

export function sortSelectedEventsByRowIndex(selected_events) {
	const index_of_event_id = returnIndexOfEventIds();

	selected_events = selected_events
		.map((event_id) => {
			return {
				row_index: index_of_event_id[event_id],
				event_id,
			};
		})
		.sort((a, b) => a.row_index - b.row_index);

	return selected_events.map((event_info) => event_info.event_id);
}

export const customColumnSanitize = (value) => {
	// eslint-disable-next-line no-useless-escape
	return value.trim().replace(/[.,\/#!$%\^&\*;:{}=\-_`'"~()]/g, '');
};

export const isValidCustomColumnName = (value) => {
	// eslint-disable-next-line no-useless-escape
	return /^[a-zA-Z0-9\s]+$/.test(value);
};

export const sanitizeHtml = (text) => {
	// Only allow specific HTML tags (strong, b, i, em)
	const allowed_tags = ['strong', 'b', 'i', 'em'];
	const div = document.createElement('div');
	div.innerHTML = text;

	// Remove all tags except allowed ones
	const elements = div.getElementsByTagName('*');
	for (let i = elements.length - 1; i >= 0; i--) {
		const element = elements[i];
		if (!allowed_tags.includes(element.tagName.toLowerCase())) {
			element.replaceWith(element.textContent);
		}
	}

	return div.innerHTML;
};

/**
 * Vue directive for auto-resizing select elements based on their selected option text
 * Usage: v-auto-resize-select="{ minWidth: 80, maxWidth: 300 }"
 */
export const autoResizeSelect = {
	mounted(el, binding) {
		const options = binding.value || {};
		const min_width = options.minWidth || 80;
		const max_width = options.maxWidth || 300;

		const adjustWidth = () => {
			// Create a temporary span to measure text width
			const temp_span = document.createElement('span');
			temp_span.style.visibility = 'hidden';
			temp_span.style.position = 'absolute';
			temp_span.style.whiteSpace = 'nowrap';
			temp_span.style.fontSize = window.getComputedStyle(el).fontSize;
			temp_span.style.fontFamily = window.getComputedStyle(el).fontFamily;
			temp_span.style.fontWeight = window.getComputedStyle(el).fontWeight;
			temp_span.style.padding = window.getComputedStyle(el).padding;

			// Get the selected option text
			const selected_option = el.options[el.selectedIndex];
			const text = selected_option ? selected_option.text : '';

			temp_span.textContent = text;
			document.body.appendChild(temp_span);

			// Calculate width with some padding for the dropdown arrow
			const text_width = temp_span.offsetWidth;
			const arrow_width = 20; // Space for dropdown arrow
			const padding = 16; // Additional padding
			const calculated_width = Math.max(min_width, Math.min(max_width, text_width + arrow_width + padding));

			// Apply the width
			el.style.width = `${calculated_width}px`;

			// Clean up
			document.body.removeChild(temp_span);
		};

		// Store the adjust function on the element for later use
		el._adjustWidth = adjustWidth;

		// Initial adjustment
		adjustWidth();

		// Listen for change events
		el.addEventListener('change', adjustWidth);
	},

	updated(el) {
		// Re-adjust when the directive options change
		if (el._adjustWidth) {
			el._adjustWidth();
		}
	},

	unmounted(el) {
		// Clean up event listener
		el.removeEventListener('change', el._adjustWidth);
		delete el._adjustWidth;
	},
};

export async function sha256HashOfArray(array) {
	// Sort object keys for consistent hashing
	const normalize = (obj) => JSON.parse(JSON.stringify(obj, Object.keys(obj).sort()));

	// Normalize and sort the array (optional: only if order shouldn't matter)
	const normalized_array = array.map(normalize);

	const json = JSON.stringify(normalized_array);
	const encoder = new TextEncoder();
	const data = encoder.encode(json);

	const hash_buffer = await crypto.subtle.digest('SHA-256', data);
	const hash_array = Array.from(new Uint8Array(hash_buffer));
	const hash_hex = hash_array.map((b) => b.toString(16).padStart(2, '0')).join('');
	return hash_hex;
}

// Recursively sort all keys in an object or array
function deepSort(obj) {
	if (Array.isArray(obj)) {
		return obj.map(deepSort);
	} else if (obj && typeof obj === 'object') {
		return Object.keys(obj)
			.sort()
			.reduce((result, key) => {
				result[key] = deepSort(obj[key]);
				return result;
			}, {});
	}
	return obj;
}

export async function sha256HashOfObject(obj) {
	const normalized = deepSort(obj);
	const json = JSON.stringify(normalized);
	const encoder = new TextEncoder();
	const data = encoder.encode(json);

	const hash_buffer = await crypto.subtle.digest('SHA-256', data);
	const hash_array = Array.from(new Uint8Array(hash_buffer));
	const hash_hex = hash_array.map((b) => b.toString(16).padStart(2, '0')).join('');
	return hash_hex;
}

export function maxAudioBoxFilenameLength(firmware_version) {
	if (firmware_version < 5.1) return 12;
	if (firmware_version >= 6.0) return 31;
	return 45;
}

export function getShowDataObjectForHash(detransformed_show_data) {
	const object_to_hash = {
		show_ID: detransformed_show_data.show_ID,
		firmware_version: detransformed_show_data.firmware_version,
		uses_audio: detransformed_show_data.script_atributes.use_audio_box,
		// audio_file_id: detransformed_show_data.audio_file_id, // EVS-1058: audio_file_id is set exclusively via the dedicated audio endpoint; including it here allows stale sessions to overwrite the server's correct value
		audio_box_filename: detransformed_show_data.audio_box_filename,
		script_name: detransformed_show_data.script_name,
		custom_name: detransformed_show_data.custom_name,
		custom_columns: detransformed_show_data.custom_columns,
		script_atributes: detransformed_show_data.script_atributes,
		cues: detransformed_show_data.cues,
		estimated_show_duration: detransformed_show_data.estimated_show_duration,
		disable_firing_groups: detransformed_show_data.disable_firing_groups,
		defined_positions: detransformed_show_data.defined_positions || [], // Normalize undefined/null to [] so the hash is consistent regardless of whether the field was ever set
	};

	return object_to_hash;
}
